import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/studio/portalKit";

// fields: [{key, label, type?, options?, required?}]
export const PromptDialog = ({ open, title, fields, initial = {}, confirm = "Save", onClose, onSubmit }) => {
  const [v, setV] = useState(initial);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setV(initial); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const ok = fields.every((f) => !f.required || String(v[f.key] ?? "").trim());
  const go = async () => { setBusy(true); await onSubmit(v); setBusy(false); };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="prompt-dialog" className="max-h-[90vh] overflow-y-auto">
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          {fields.map((f) => (
            <Field key={f.key} label={`${f.label}${f.required ? " *" : ""}`}>
              {f.options ? (
                <select data-testid={`prompt-${f.key}`} className="h-10 w-full rounded-md border border-input bg-white px-3 text-sm"
                  value={v[f.key] || ""} onChange={(e) => setV({ ...v, [f.key]: e.target.value })}>
                  <option value="">Choose…</option>{f.options.map((o) => <option key={o}>{o}</option>)}
                </select>
              ) : (
                <Input data-testid={`prompt-${f.key}`} type={f.type || "text"} value={v[f.key] ?? ""}
                  onChange={(e) => setV({ ...v, [f.key]: e.target.value })} />
              )}
            </Field>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button data-testid="prompt-confirm-btn" disabled={!ok || busy} onClick={go} className="bg-crimson-500 hover:bg-crimson-600">{confirm}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
